module.exports = __webpack_public_path__ + "static/card-grants-b5c5bc4aaf68b320aa8727a111ba8024.jpg";